import { Component, OnInit } from '@angular/core';
//import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthService } from '../../../services/okta-auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor( private oktaAuthService: OktaAuthService) { }

  ngOnInit(): void {
    this.login();
  }

  async login() {
    await this.oktaAuthService.getOktaAuth().signInWithRedirect();
  }
}
